module.exports = __webpack_public_path__ + "static/media/striped_bar_preinspect_tall.32c156a8.svg";